<template>
  <div class="container-fluid bg-light text-dark" dir="rtl">
    <div class="customer-info">
      <div class="row p-3 mx-1">
        <div class="col-2 p-0">
          <img :src="$cookies.get('URL') + $session.get('CompanyLogo')" alt="Logo" style="max-width: 40%" />
        </div>
        <div class="col-md-12 col-12 text-center">
          <span class="mb-3 font-weight-bold mr-5 text-dark" style="font-size: 20px">صورتحساب فروش کالا و خدمات</span>
        </div>
        <div class="col-md-12 col-12 text-center">
          <span class="float-left text-dark">
            <small class="text-dark"> شماره سریال : </small>{{ DataAxios.SerialId }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <small> تاریخ : </small><span class="text-dark">{{ DataAxios.IssueDate }}</span>
          </span>
        </div>
      </div>
      <!-- فروشنده -->
      <div class="row mt-2 pt-1 mx-1 D_Products Font-Size bg-light">
        <div class="col-12 text-center border-bottom bg_RowSum mb-3 font-weight-bold">مشخصات فروشنده</div>
        <div class="col-12">
          <div class="">
            نام شخص حقیقی | حقوقی : <b>{{ Shobe.NameShobe }}</b>
          </div>
        </div>

        <div class="col-12">
          <div class="">
            نشانی کامل : <b>{{ Shobe.Adres }} </b>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <!-- {{Shobe.ShenaseMeli}} -->
            <div class="col-md-3 col-12">
              شماره ثبت | شماره ملی : <b> {{ Shobe.SabtNo }} </b>
            </div>
            <div class="col-md-3 col-12">
              شماره اقتصادی : <b>{{ Shobe.ShenaseEghtesadi }} </b>
            </div>
            <div class="col-md-3 col-12">
              کد پستی : <b>{{ Shobe.CodePosti }}</b>
            </div>
            <div class="col-md-3 col-12">
              شماره تلفن : <b>{{ Shobe.Tel }}</b>
            </div>
          </div>
        </div>
      </div>

      <!-- خریدار -->
      <div class="row mt-1 mx-1 D_Products Font-Size bg-light">
        <div class="col-12 text-center border-bottom bg_RowSum mb-3 font-weight-bold">مشخصات خریدار</div>
        <div class="col-12">
          <div class="" v-if="CustomerFinancial.tblComboGrpId50CustomerFactorType == 2001">
            نام شخص حقیقی : <b>{{ CustomerFinancial.Name }}</b>
          </div>
          <div class="" v-else>
            نام شرکت حقوقی : <b>{{ CustomerFinancial.Name }}</b>
          </div>
        </div>

        <div class="col-12">
          <div class="">
            نشانی کامل : <b v-if="Customer.Adress">{{ Customer.Adress[0].State }} - {{ Customer.Adress[0].City }} - {{ Customer.Adress[0].Adress }} </b>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 col-12" v-if="CustomerFinancial.tblComboGrpId50CustomerFactorType == 2001">
              کد ملی : <b>{{ CustomerFinancial.ShomareMeli }}</b>
            </div>
            <div class="col-md-3 col-12" v-else>
              شماره ملی : <b>{{ CustomerFinancial.ShomareMeli }}</b>
            </div>

            <div class="col-md-3 col-12" v-if="CustomerFinancial.tblComboGrpId50CustomerFactorType == 2002">
              شماره اقتصادی : <b>{{ CustomerFinancial.CodeEghtesadi }}</b>
            </div>
            <div class="col-md-3 col-12">
              کد پستی : <b v-if="Customer.Adress">{{ Customer.Adress[0].CodePosti }}</b>
            </div>
            <div class="col-md-3 col-12">
              شماره تلفن : <b v-if="Customer.Adress">{{ Customer.Adress[0].Tel }}</b>
            </div>
          </div>
        </div>
      </div>

      <!--Header Serial And Date -->
      <div class="row mt-2 mx-1 D_Products">
        <div class="col-12 text-center Font-Size bg_RowSum font-weight-bold">اطلاعات کالا و یا خدمات مورد معامله</div>
      </div>
    </div>
    <!-- Serial And Date -->
    <div>
      <table class="table table-bordered table-striped">
        <thead class="table-header-group">
          <tr style="text-align: center; background: #c6c7c7 !important">
            <th style="width: 1% !important; background: #c6c7c7 !important">ردیف</th>
            <th style="width: 5% !important; background: #c6c7c7 !important">کد کالا</th>
            <th style="width: 30% !important; background: #c6c7c7 !important">شرح کالا | خدمات</th>
            <th style="width: 5% !important; background: #c6c7c7 !important">تعداد</th>
            <th style="width: 10% !important; background: #c6c7c7 !important">مبلغ واحد <small>( ریال )</small></th>
            <th style="background: #c6c7c7 !important">مبلغ کل <small class="d-block">( ریال )</small></th>
            <th style="width: 10% !important; background: #c6c7c7 !important">مبلغ تخفیف</th>
            <th style="width: 10% !important; background: #c6c7c7 !important">مبلغ پس از تخفیف <small class="d-block">( ریال )</small></th>
            <th style="width: 10% !important; background: #c6c7c7 !important" v-if="DataAxios.IsRasmi">جمع مالیات و عوارض <small>( ریال )</small></th>
            <th style="background: #c6c7c7 !important" v-if="DataAxios.IsRasmi">جمع مبلغ با احتساب مالیات و عوارض <small>( ریال )</small></th>
            <th style="background: #c6c7c7 !important" v-else>جمع مبلغ کل <small>( ریال )</small></th>
          </tr>
        </thead>
        <tbody class="" id="GFactor">
          <tr v-for="(item, index) in ListProducts" :key="index">
            <td style="width: 1% !important">
              <span class="text-dark">{{ index + 1 }}</span>
            </td>
            <td style="width: 5% !important">
              <span class="text-dark">{{ item.Id }}</span>
            </td>

            <td style="width: 30% !important; text-align: center">{{ item.Name }}</td>
            <td style="width: 5% !important; text-align: center">{{ Math.floor(item.Count) }}</td>
            <td style="width: 10% !important; text-align: center">{{ $Comma3ragham(Math.floor(item.Amount)) }}</td>
            <td style="text-align: center">{{ $Comma3ragham(item.AmountKol) }}</td>
            <td style="width: 10% !important; text-align: center">{{ $Comma3ragham(Math.floor(item.Discount)) }}</td>
            <td style="width: 10% !important; text-align: center">{{ $Comma3ragham(Math.floor(item.Miniaturize_AmountDiscount)) }}</td>
            <td style="width: 10% !important; text-align: center" v-if="DataAxios.IsRasmi">{{ $Comma3ragham(Math.floor(item.SumTollTax)) }}</td>
            <td style="text-align: center">
              <span class="text-dark">{{ $Comma3ragham(Math.floor(item.TotallAmount)) }}</span>
            </td>
          </tr>
          <tr v-if="ListProducts.length > 0">
            <td colspan="5" style="text-align: left" class="bg-light">جمع کـــل :</td>
            <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(Math.floor(TR_Result.S_Amount))}}</td>
            <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(Math.floor(TR_Result.S_Discount)) }}</td>
            <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(Math.floor(TR_Result.S_Miniaturize_AmountDiscount)) }}</td>
            <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum" v-if="DataAxios.IsRasmi">{{ $Comma3ragham(Math.floor(TR_Result.S_SumTollTax)) }}</td>
            <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(Math.floor(TR_Result.S_SumTotallAmount)) }}</td>
          </tr>
          <tr v-if="ListProducts.length > 0" class="mt-3">
            <td colspan="5" style="text-align: right">توضیحات : {{ DataAxios.Description }}</td>
            <td colspan="5" style="text-align: right">
              <span class="mt-2 text-dark">
                جمع کل مبلغ به حروف : <b class="font-weight-bold"> {{ Mab2persian(Math.floor(TR_Result.S_SumTotallAmount)) }}</b></span
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="px-3">
        <span class="float-right text-dark">مهر و امضا فروشنده</span>
        <span class="float-left text-dark">مهر و امضای خریدار</span>
      </div>
    </div>

    <div class="d-block mt-5" v-if="$route.name != 'FactorManager'">
      <span class="bg-success no-print mt-5 px-3 text-light Pointer" @click="print">چاپ سند</span>
    </div>
  </div>
</template>
<script>
import Num2persian from 'num2persian'
export default {
  data() {
    return {
      ArzeshAfzode1402:0.09,
      ArzeshAfzode1403 :0.1,
      IsTarixFactor:false,
      ListProducts: [],
      TR_Result: {
        S_Amount: 0,
        S_Discount: 0,
        S_Miniaturize_AmountDiscount: 0,
        S_SumTollTax: 0,
        S_SumTotallAmount: 0,
      },
      DataAxios: { IssueDate: '', SerialId: null, tblCustomerId: 0, tblShobeId: 0, IsRasmi: false },
      Customer: [],
      Shobe: {},
      CustomerFinancial: {},
    }
  },
  props: ['propsFactor'],
  mounted() {
    if (this.$route.name == 'FactorManager') {
      this.ListProducts = this.propsFactor.tblFactorCustomerProducts
      this.DataAxios.SerialId = this.propsFactor.SerialId
      this.DataAxios.IssueDate = this.propsFactor.IssueDate
      this.DataAxios.Description = this.propsFactor.Description
      this.DataAxios.tblCustomerId = this.propsFactor.tblCustomerId
      this.Getfullcustomer(this.DataAxios.tblCustomerId)
      this.DataAxios.tblShobeId = this.propsFactor.tblShobeId
      this.GetShobe()
      this.CalcFactor()
      this.GetFinancial(this.DataAxios.tblCustomerId)
    } else {
      this.ListProducts = this.$route.params.propsFactor.tblFactorCustomerProducts
      this.DataAxios.SerialId = this.$route.params.propsFactor.SerialId
      this.DataAxios.IssueDate = this.$route.params.propsFactor.IssueDate
      this.DataAxios.Description = this.$route.params.propsFactor.Description
      this.DataAxios.tblCustomerId = this.$route.params.propsFactor.tblCustomerId
      this.Getfullcustomer(this.DataAxios.tblCustomerId)
      this.DataAxios.tblShobeId = this.$route.params.propsFactor.tblShobeId
      this.GetShobe()
      this.CalcFactor()
      this.GetFinancial(this.DataAxios.tblCustomerId)
    }
  },
  methods: {
    print() {
      var css = `@page {
         size: landscape;
       }
      @media print
        {
          body {
                margin: 0;
                padding-top: 100px; /* فاصله مورد نظر خود را تنظیم کنید */
            }
          
    html {
        overflow: visible !important;
        }
   .customer-info {
      position: fixed;
      top: 0;
      left: 0;

        }
      table{
          page-break-inside: avoid; /* Prevent table rows from breaking across pages */
          margin-top:8cm
        }
        .trmargin{
        height:8cm !important; 
        }
      tbody {
          display: table-row-group; /* Ensure the table body is treated as a group */
        }
      thead {
           display: table-header-group !important; /* Ensure the header appears on each page */
        }
         
   
     
}
              `,
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style')

      style.type = 'text/css'
      style.media = 'print'

      if (style.styleSheet) {
        style.styleSheet.cssText = css
      } else {
        style.appendChild(document.createTextNode(css))
      }

      head.appendChild(style)

      window.print()
    },
    CalcFactor() {
      this.TR_Result.S_Amount = 0
      this.TR_Result.S_Discount = 0
      this.TR_Result.S_Miniaturize_AmountDiscount = 0
      this.TR_Result.S_SumTollTax = 0
      this.TR_Result.S_SumTotallAmount = 0

      this.ListProducts.forEach((el) => {
        if (el.tblComboGrpId12 == 1226) {
          //رسمی
          this.DataAxios.IsRasmi = true
        }
        if (el.tblComboGrpId12 == 1227) {
          //غیر رسمی
          this.DataAxios.IsRasmi = false
        }

        this.TR_Result.S_Amount += Number(el.AmountKol)

        if (typeof el.Discount === 'string') this.TR_Result.S_Discount += Number(el.Discount.replace(/,/g, '').replace(/\./g, ''))
        else this.TR_Result.S_Discount += Number(el.Discount)

        var d = typeof el.Discount === 'string' ? Number(el.Discount.replace(/,/g, '').replace(/\./g, '')) : Number(el.Discount)
        this.TR_Result.S_Miniaturize_AmountDiscount += Number(el.AmountKol) - d
        this.TR_Result.S_SumTollTax += Number(el.AmountKol - d) * (this.DataAxios.IssueDate.substring(0, 4)<'1403' ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403) 
        this.TR_Result.S_SumTotallAmount += Number(el.TotallAmount)
      })
    },
    Mab2persian(mab) {
      return Num2persian(mab) + ' ریال '
    },
    Getfullcustomer(IdCustomer) {
      var DataAxiosGetCustomer = { Action: 'TblCustomerCrm/GetFullCustomer', Method: 'Post', ArryfildValue: { id: IdCustomer } }
      this.$PostData(DataAxiosGetCustomer).then((result) => {
        this.Customer = result
      })
    },
    GetShobe() {
      var DataAxiosGetShobe = { Action: 'DefineShobe', Method: 'get', ArryfildValue: {} }
      this.$PostData(DataAxiosGetShobe).then((result) => {
        // console.log(result)
        result.forEach((sh) => {
          if (sh.Id == this.DataAxios.tblShobeId) {
            this.Shobe = sh
            // console.log(this.Shobe);
          }
        })
      })
    },
    GetFinancial(Id) {
      let DataAxios_GetData = { ArryfildValue: {}, Method: 'post', Action: 'CustomerFinancialInvoice/GetCustomerFinancialInvoice', Token: this.$session.get('Token') }
      DataAxios_GetData.ArryfildValue.Id = Id
      this.$PostData(DataAxios_GetData)
        .then((data) => {
          data.forEach((el) => {
            if (el.Archive == false) {
              this.CustomerFinancial = el
            }
          })
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
  },
}
</script>
<style>
/* ::-webkit-scrollbar-track {
  background:rgb(236, 23, 23) !important; 
  
} */
</style>
<style scoped>
.D_Products {
  border: 1px solid #dbdddc;
  border-radius: 5px;
}
.bg_RowSum {
  background: #c6c7c7 !important;
}
@media print {
  .no-print {
    display: none;
  }
}
table td {
  color: #000 !important;
  font-size: 10px !important;
}
table th {
  color: #000 !important;

  font-weight: bold !important;
  font-size: 11px !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #e5eaea !important;
}
.table-striped > tbody > tr:nth-child(2n) > td,
.table-striped > tbody > tr:nth-child(2n) > th {
  background-color: #fff !important;
}
b {
  font-weight: bold !important;
}
.Font-Size {
  font-size: 11px !important;
}

td {
  border-color: rgb(137, 137, 137) !important;
}
th {
  border-color: rgb(137, 137, 137) !important;
}
thead {
  border-color: rgb(137, 137, 137) !important;
}
</style>
